'use client'

import { Label } from '@/components/ui/label'
import { Switch } from '@/components/ui/switch'

import { useAccessibility } from '../AccessibilityProvider'

export function FocusSection() {
  const { settings, update, announce } = useAccessibility()

  return (
    <section aria-labelledby="a11y-focus-heading" className="flex flex-col gap-4">
      <h3 id="a11y-focus-heading" className="text-base font-semibold">
        Fokus
      </h3>

      <div className="flex items-start justify-between gap-3">
        <Label htmlFor="enhanced-focus" className="flex flex-1 cursor-pointer flex-col gap-0.5">
          <span>Povećan indikator fokusa</span>
          <span className="text-muted-foreground text-xs font-normal">
            Deblji okvir oko trenutno aktivnog elementa kad koristiš tastaturu
          </span>
        </Label>
        <Switch
          id="enhanced-focus"
          checked={settings.enhancedFocus}
          onCheckedChange={(checked) => {
            update({ enhancedFocus: checked })
            announce(`Povećan fokus: ${checked ? 'uključen' : 'isključen'}`)
          }}
        />
      </div>
    </section>
  )
}
